var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOffset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 135.47 135.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26.979,
    y: 102.75,
    width: 87.826,
    height: 6.8883,
    fill: "#a7a7a7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26.692,
    y: 31.571,
    width: 87.826,
    height: 6.8883,
    fill: "#0e7afe"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m70.22 94.88c0.1353-15.559 0.2706-31.119 0.4059-46.678",
    fill: "none",
    markerEnd: "",
    stroke: "#0f79fd",
    strokeWidth: 3.9966
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m60.073 59.872 10.553-11.67 10.452 11.467",
    fill: "none",
    stroke: "#0f79fd",
    strokeWidth: 3.9966
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffset);
export default __webpack_public_path__ + "static/media/offset.780691bed2f92639d969f67c1e0b7902.svg";
export { ForwardRef as ReactComponent };